module.exports = __webpack_public_path__ + "static/media/tshirt_500.c210b604.jpg";